export const introTopCaption = `あの大人気コミックが新たに連続ドラマとして復活！！
高校で写真部部長の相羽英男のクラスに美少女の早華胡桃が転校してくると
全てが自分のツボの胡桃に恋心を抱く相羽。しかし彼女の小悪魔的な態度や行動に
いつしか翻弄されていく。二人の歪でSM的な関係の行方は！
`;

export const introMiddleCaption = `主演の早華胡桃役として女優デビューする新唯は、
「ミスSPA！2022」グランプリを受賞した元看護師で、テレビやバラエティ、
そしてレースクィーンや那須川天心のボクシングデビュー戦に
リングガールとして登場し話題を振りまいた逸材。
相手役の相羽英男には、子役時代から「真夏の方程式」「ツナグ」に出演し、
映画・ドラマ・舞台で活躍する山﨑光が胡桃の虜になっていく男子高校生を好演する。
共演には、西野夢菜、パピコ、伊織いお、新井萌花など多数のグラビアアイドルや、
昨年1st写真集も発表し泣けるリングガールとしても話題の天野麻菜が出演していることでも話題。
`;

export const introBottomSubTitle = `かつて“ピュア”だった、すべての人に贈る青春エロティックラブコメディ！`;
